module.exports = __webpack_public_path__ + "static/img/banner-bg.a6823df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/dec/banner-bg.png
// module id = coPi
// module chunks = 34